module.exports = __webpack_public_path__ + "static/media/ReggieSmith.d0ee717a.jpg";